import { WorkShift } from "../_modelsTS/WorkShift";

export class WorkShiftMapper {
    static mapTimeSlotsServerToLocal(
        slots: {
            uid: string, 
            start: string, 
            end: string, 
            weekday: number | string 
        }[]) {

        if (!slots?.length) return null;
    
        let res = {};
    
        slots.forEach(({ uid, start, end, weekday }) => {
            res = {
                ...res,
                [weekday]: WorkShiftMapper.orderTimeSlots([...(res[weekday] ?? []), { uid, start, end }])
            }
        })
    
        return res;
    }

    static orderTimeSlots(timeSlots: WorkShift[]) {
        return timeSlots.sort((a, b) => a.start.localeCompare(b.start));
    }
}